module.exports = __webpack_public_path__ + "img/cat-hand-pen.b05bb505.svg";